<app-product-push-list-atom
  displayContext="shop_page"
  [products]="products"
  [tagColors]="tagColors"
  (navigateTo)="onNavigateTo($event)"
></app-product-push-list-atom>
